import React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";
import slugify from "slugify";
import { setTagFilter, setTopicFilter } from "../../actions/actions";
import { extractTagsFromInsights, extractTopicsFromInsights } from "../selectors/filters";
import * as ENUMS from "../../enums/enums";
import * as SIZES from "../../enums/sizes";
import * as COLOURS from "../../enums/colours";

const CardFilters = ({ dispatch, filters, topics, tagFilter, topicFilter }) => {
  const selectFilter = filter => {
    dispatch(setTagFilter(filter === tagFilter ? null : filter));
  };

  const selectTopic = topic => {
    dispatch(setTopicFilter(topic === topicFilter ? null : topic))
  }

  return (
    <React.Fragment>

      <FiltersWrapper className="span-10">
        {filters.map(item => (
          <FilterButton
            key={`filter--${slugify(item)}`}
            item={item}
            selected={tagFilter === item}
            selectFilter={selectFilter}
          />
        ))}
      </FiltersWrapper>

      {topics.length > 0 && <FiltersWrapper className="span-10">
        {topics.map(topic => (
          <FilterButton
            key={`topic--${slugify(topic)}`}
            item={topic}
            selected={topicFilter === topic}
            selectFilter={selectTopic}
            isFilter={true}
          />
        ))}
      </FiltersWrapper>}

    </React.Fragment>
  );
};

const FilterButton = props => {
  let buttonBackground = COLOURS.darkGrey
  if (ENUMS.DEFAULT_CARD_TAGS[props.item]) {
    buttonBackground = ENUMS.DEFAULT_CARD_TAGS[props.item];
  }

  if (props.isFilter) {
    buttonBackground = '#2A61AD';
  }

  if (props.selected) {
    buttonBackground = '#23344A';
  }

  return (
    <FilterButtonElement
      selected={props.selected}
      onClick={() => props.selectFilter(props.item)}
      style={{backgroundColor: buttonBackground, paddingLeft: props.selected ? '.5rem' : '1rem'}}
    >
      {props.selected && <svg xmlns="http://www.w3.org/2000/svg"
            style={{width: 15, height: 15, marginRight: 4}} fill="none"
            viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"/>
      </svg>}
      {props.item}
    </FilterButtonElement>
  );
};

const FiltersWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: ${SIZES.sizeHl};

  button {
    margin-right: ${SIZES.sizeSm};
  }

  button:last-child {
    margin-right: 0;
  }
`;

const FilterButtonElement = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 2rem;
  margin-bottom: ${SIZES.sizeHl};
  padding: 0 ${SIZES.sizeRg};
  font-size: 0.7rem;

  ${props =>
    !props.selected &&
    css`
      background-color: ${COLOURS.darkGrey};
      color: ${COLOURS.white};
    `};
`;

const mapStateToProps = state => {
  return {
    filters: extractTagsFromInsights(state),
    topics: extractTopicsFromInsights(state),
    tagFilter: state.tagFilter,
    topicFilter: state.topicFilter
  };
};

export default connect(mapStateToProps)(CardFilters);



// WEBPACK FOOTER //
// ./src/cardFilters/components/CardFilters.js